/**
 * @generated SignedSource<<43a7d0708ae6da7d46b7dd8f65aa6cbf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSidebarDetailsShipping_user$data = {
  readonly serviceId: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedDetailShipping_user">;
  readonly " $fragmentType": "PdpRespSidebarDetailsShipping_user";
};
export type PdpRespSidebarDetailsShipping_user$key = {
  readonly " $data"?: PdpRespSidebarDetailsShipping_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSidebarDetailsShipping_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSidebarDetailsShipping_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedDetailShipping_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "44b4093dff3baab2cf59d13f15cf6831";

export default node;
